import { Star, ExternalLink } from "lucide-react";

// TODO: Replace with real Google review link once GBP is claimed
const GOOGLE_REVIEW_LINK = "https://g.page/r/blue-collar-world-pest-control/review";

const ReviewCTA = () => {
  return (
    <section className="border-b border-zinc-900 bg-[#F59E0B]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="flex items-center gap-3 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 text-black fill-black" />
            ))}
            <span className="font-display uppercase text-3xl md:text-4xl tracking-tight text-black">
              5.0
            </span>
          </div>
          <h2 className="font-display uppercase text-3xl md:text-5xl font-semibold tracking-tighter text-black leading-none mb-3">
            Loved us? Say so on Google.
          </h2>
          <p className="text-black/80 text-base md:text-lg max-w-xl">
            30 seconds of your time helps a Pittsburgh small business hit the top of Google. It's the single biggest thing you can do for us — thank you.
          </p>
        </div>
        <div className="md:col-span-4 flex md:justify-end">
          <a
            href={GOOGLE_REVIEW_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-review-cta"
            className="inline-flex items-center gap-3 bg-black text-white px-7 py-5 font-display uppercase tracking-tight text-base hover:bg-zinc-800 border-2 border-black hard-shadow"
          >
            Leave a Google Review
            <ExternalLink className="w-4 h-4" strokeWidth={2.5} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewCTA;
